import { Group } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { exportMultiReport } from "../../../services/report";
import {
  useSelectFiltersDailyForOverlimit,
  useSelectReportsDailyForOverlimit,
} from "../../../redux/features/reports/dailyForOverlimitSlice";
import { toast } from "react-toastify";
import { REPORT_EXPORT_TYPE, REPORT_TYPES } from "../constants";
import ExportFileButton from "../../../components/ExportFileButton/ExportFileButton";

const downloadBlobResponse = (response) => {
  const fileName =
    response.headers["content-disposition"]?.split("filename=")[1];

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};

const ExportDailyReports = () => {
  const { t } = useTranslation();
  const [currentType, setCurrentType] = useState(null);

  const filters = useSelectFiltersDailyForOverlimit();
  const reports = useSelectReportsDailyForOverlimit();

  const dailyReportDownloadFile = useMutation({
    mutationKey: ["daily-for-overlimit-download-file"],
    mutationFn: (reportExportType) =>
      exportMultiReport({
        type: REPORT_TYPES.DAILY,
        limit: filters?.limit || "",
        product: filters?.product || "",
        sumAboveTheLimit: filters?.sumAboveTheLimit || "",
        transactionType: filters?.transactionType || "",
        forExport: true,
        reportExportType,
      }),
    onSuccess: downloadBlobResponse,
    onError: ({ message }) => {
      toast.error("Export error " + message);
    },
  });

  const handleDownload = async (option) => {
    setCurrentType(option);
    await dailyReportDownloadFile.mutateAsync(option);
    setCurrentType(null);
  };

  const loading = dailyReportDownloadFile.isPending;
  const noData = reports.length === 0;
  const disabled = loading || noData;

  return (
    <Group>
      <ExportFileButton
        handleDownload={() => handleDownload(REPORT_EXPORT_TYPE.PDF)}
        disabled={disabled}
        loading={loading && currentType === REPORT_EXPORT_TYPE.PDF}
        tooltipLabel={t("reports.exportPdf")}
        type={REPORT_EXPORT_TYPE.PDF}
      />
      <ExportFileButton
        handleDownload={() => handleDownload(REPORT_EXPORT_TYPE.EXCEL)}
        disabled={disabled}
        loading={loading && currentType === REPORT_EXPORT_TYPE.EXCEL}
        tooltipLabel={t("reports.exportExcel")}
        type={REPORT_EXPORT_TYPE.EXCEL}
      />
    </Group>
  );
};

export default ExportDailyReports;
